// extracted by mini-css-extract-plugin
module.exports = {"notes":"note_notes__1h9D6","menu":"note_menu__21EGO","content":"note_content__2dIFt","view_more":"note_view_more__2RIW5"};